import { loadSvg } from '../common/utils';

const els = {
    $button: () => $('.arrow-button'),
};

const trim = (html) => (
    html.replace(/>\s+</g, '><')
);

const initializeButton = ($button) => {

    const text = $button.html();
    const icon = loadSvg('arrowhead');

    const $text = $(trim(`
        <div class="arrow-button__text">
            ${text}
        </div>
    `));

    const $icon = $(trim(`
        <div class="arrow-button__icon">
            <div class="arrow-button__shaft"></div>
            <div class="arrow-button__point">
                ${icon}
            </div>
        </div>
    `));

    $button
        .empty()
        .append($text)
        .append($icon);
};

const initialize = () => {
    els.$button().each(
        (index, element) => (
            initializeButton($(element))
        )
    );
};

export default {
    initialize,
};

